/** Parse GraphQL Decimal usage values to a number for display and UI math. */
export const parseUsageValue = (value: string | number | null | undefined): number => {
  if (value == null) {
    return 0;
  }
  const parsed = typeof value === 'number' ? value : Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

/** Format usage units as a whole number for display; show "<1" for positive usage below one unit. */
export const formatUsageUnits = (value: string | number | null | undefined): string => {
  const parsed = parseUsageValue(value);
  if (parsed <= 0) {
    return '0';
  }
  if (parsed < 1) {
    return '<1';
  }
  return new Intl.NumberFormat('en-US').format(Math.round(parsed));
};
